import { Container } from "./styles";
import { ErrorIcon } from "../../assets/common";

interface NotificationErrorProps {
  message: string;
}

function NotificationError({ message }: NotificationErrorProps) {
  return (
    <Container message={message}>
      <img src={ErrorIcon} alt="" />
      <em>{message}</em>
    </Container>
  );
}

export default NotificationError;
